export function LoadingScreen() {
  return (
    <div className="min-h-screen bg-substrate-deep flex items-center justify-center">
      <div className="flex flex-col items-center gap-3 animate-pulse">
        <span className="font-display font-bold text-2xl text-copper text-emission">
          Rats Nest
        </span>
        <span className="text-sm text-ratsnest-muted">Loading...</span>
      </div>
    </div>
  );
}
